<template>
  <div class="card">
    <div class="card-header text-center">
      {{ $I18n.t('Turnos') }}
    </div>
    <div class="lista-turnos card-calendar-body-height" style="overflow: auto;">
      <table class="table">
        <tbody>
          <tr
            v-for="turno in turnosOrdenados"
            :key="turno.id"
            class="clickable"
            :class="{ 'active bg-cifra' : estaSeleccionado(turno) }"
            @click="seleccionarTurno(turno)"
          >
            <td>{{ turno.ruta.nombre }}</td>
            <td>{{ turno.nombre }}</td>
            <td>{{ dateToTimeString(turno.hora) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import { transporte } from 'cifra-api-js';
import { dateToTimeString } from '../../../libs/dates';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    paramsTurnos: {
      type: Object,
      default: () => ({}),
    },
    modelValue: {
      type: [Object, Array],
      default: (rawProps) => {
        if (rawProps.multiple) {
          return [];
        }
        return {};
      },
    },
    editable: { type: Boolean, default: true },
    sortBy: { type: [Array, String], default: () => ['ruta.nombre', 'nombre'] },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      cargaInicialHecha: false,
      turnos: [],
    };
  },
  computed: {
    turnosOrdenados() {
      return sortBy(this.turnos, this.sortBy);
    },
  },
  watch: {
    paramsTurnos() {
      if (this.editable || !this.cargaInicialHecha) {
        this.loadTurnos(this.paramsTurnos);
      }
    },
  },
  mounted() {
    this.loadTurnos(this.paramsTurnos);
  },
  methods: {
    loadTurnos(params) {
      if (!Object.keys(params).length) {
        if (this.cargaInicialHecha) {
          this.inicializarValue();
        }
        return;
      }

      transporte.turnos.get({ params }).then((result) => {
        this.turnos = result.data;
        // Si no es editable solo mostramos el seleccionado
        if (!this.editable) {
          let ids;
          if (Array.isArray(this.modelValue)) {
            ids = this.modelValue.map((e) => e.id);
          } else {
            ids = [this.modelValue.id];
          }
          this.turnos = this.turnos.filter((turno) => ids.includes(turno.id));
        }

        // La primera vez no limpiamos, usamos el valor inicial
        if (this.cargaInicialHecha) {
          // Si no es editable y ya lo hemos cargado, ignoramos
          if (!this.editable) {
            return;
          }
          this.inicializarValue();
        } else {
          this.cargaInicialHecha = true;
        }
      });
    },
    estaSeleccionado(turno) {
      if (this.multiple) {
        return !!this.modelValue.find((e) => e.id === turno.id);
      }

      return turno.id === this.modelValue.id;
    },
    seleccionarTurno(turno) {
      if (this.editable) {
        if (this.multiple) {
          let nuevo = [...this.modelValue];
          if (this.estaSeleccionado(turno)) {
            nuevo = nuevo.filter((e) => e.id !== turno.id);
          } else {
            nuevo.push(turno);
          }
          nuevo = sortBy(nuevo, this.sortBy);
          this.$emit('update:modelValue', nuevo);
        } else {
          this.$emit('update:modelValue', turno);
        }
      }
    },
    inicializarValue() {
      if (this.multiple) {
        this.$emit('update:modelValue', []);
      } else {
        this.$emit('update:modelValue', {});
      }
    },
    dateToTimeString,
  },
};
</script>
